import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Approval setting'

  }
];

@Component({
  selector: 'page-approve',
  templateUrl: './approve.html',
  styleUrls: ['./approve.scss']
})

export class PageApprove implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  cksearch:boolean=false;
  form: FormGroup;

  approve_items=[];
  approve_levels=[];
  users = [];
  rows = [];
  temp=[];
  lines=[];

  key:any="";

  approveItemlCtrl = new FormControl();
  approveLevelCtrl = new FormControl();
  approvePersonCtrl = new FormControl();
  lineCtrl = new FormControl();
 
  fileupload:string;fileupload_:string;
  data:any;

  loadingIndicator: boolean = true;
  id:string;
  ckedit:boolean=false;
  picture:String;
  //upload file
  imageSrc:any;

  Name:string; 
  myFile:File; /* property of File type */


  dialogRefWarning: MdDialogRef<WarningApproveDialog>;
  dialogRef: MdDialogRef<approveDialog>;
  setId:any;
  sysPath:String=environment.sysPath;
  sysPathPrint:String=environment.sysPath+"/api/approve-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/approve-list-export.php";

  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
  this.getUser();
  this.getAproveItem();
  this.getLine();
  this.getStartData();
    this._sharedService.emitChange(this.pageTitle);
  }

  intervalGetData(){
    return setInterval(() => {
      if(this.setId.runCount>5){
      clearInterval(this.setId);
      }
      this.getStartData();
      console.log('------this.setId------',this.setId.runCount);
     }, 1000);
  }

  getLine(){
    this.httpservice.fetchget('getJSON_line_name.php?',(data)=>{
        this.lines = data;
    });
  }

  getStartData(){

    this.httpservice.fetchget('getJSON_approve_setting.php?',(data) => {
      this.rows = data;
      this.temp = data;
      this.loadingIndicator = false;
      console.log('------this.cksearch------',this.cksearch);
    });
  }

  getUser(){
    this.httpservice.fetchget('getJSON_operator_in_process.php?',(data)=>{
      this.users = data;
    });
  }

  getAproveItem(){
    this.httpservice.fetchget('getJSON_approve_item.php?',(data) => {
      this.approve_items = data;
    });
  }

  getApproveLevel(id:any){
    console.log('id',id);
    this.httpservice.fetchget('getJSON_approve_level.php?tb113f_id='+id,(data) => {
        this.approve_levels = data;
      });
  }

  delete(id:string){
  let val = {id:id}
  this.httpservice.fetchpost('deleteApproveSetting.php', val, (cb) => {});
  this.getStartData();
  }

  setedit(id:string){
    this.cancelEdit();
    this.id = id;
    this.ckedit=true;
    this.httpservice.fetchget('getJSON_approve_setting.php?id='+id,(data) => {
      let tb113f_id:any;
      this.form.controls.secret_code.setValue(data[0].tb112f_secret_code);
      this.picture = data[0].tb112f_sign_picture;
      tb113f_id = data[0].tb113f_id;
      this.approveItemlCtrl.setValue(data[0].tb113f_id);
      this.httpservice.fetchget('getJSON_approve_level.php?id='+data[0].tb114f_id,(data) => {    
        this.getApproveLevel(tb113f_id);  
        this.approveLevelCtrl.setValue(data[0].tb114f_id);
      });
      this.lineCtrl.setValue(data[0].tb17_productionline_tpr_id);
      this.approvePersonCtrl.setValue(data[0].tb98f_id);
      console.log();
    });
  }

  edit(){
    this.setId = this.intervalGetData();
    if (this.myFile != null) {
      this.fileupload = this.myFile.name;
    } else {
      this.fileupload = "";
    }

    this.ckedit = false;
    this.data = {
      id:this.id,
      tb113f_id:this.approveItemlCtrl.value,
      tb114f_id:this.approveLevelCtrl.value,
      tb98f_id:this.approvePersonCtrl.value,
      secret_code:this.form.controls.secret_code.value,
      filename:this.fileupload,
      tpr_id:this.lineCtrl.value
    }
    // insert data
    this.httpservice.fetchpost('editDataApproveSetting.php', this.data, (cb) => {
    //upload document
    if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
    }
    this.getStartData();
    this.form.reset();
    this.cancelEdit();
    this.picture = null;
    });

  }

  cancelEdit(){
    this.ckedit = false;
    this.approveItemlCtrl.reset();
    this.approveLevelCtrl.reset();
    this.approvePersonCtrl.reset();
    this.lineCtrl.reset();
    this.form.reset();
    this.picture = null;
  }


save(){
  this.setId = this.intervalGetData();
  if (this.myFile != null) {
    this.fileupload = this.myFile.name;
  } else {
    this.fileupload = "";
  }

  this.data = {
    id:this.id,
    tb113f_id:this.approveItemlCtrl.value,
    tb114f_id:this.approveLevelCtrl.value,
    tb98f_id:this.approvePersonCtrl.value,
    secret_code:this.form.controls.secret_code.value,
    filename:this.fileupload,
    tpr_id:this.lineCtrl.value
  }
  // insert data
  this.httpservice.fetchpost('insertDataApproveSetting.php', this.data, (cb) => {
  if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
  }
  this.getStartData();
  this.form.reset();
  this.picture = null;
  });

}

search(){

  }

  ngOnInit() {
    this.form = this.fb.group({
        secret_code: [null, Validators.compose([Validators.required])],
        fileInput: [null, Validators.compose([Validators.required])]
    });

  }

  attachFile(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc = reader.result;
      console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   console.log('File name : ',this.myFile.name);
   }


    updateFilter_item(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tb113f_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }
  updateFilter_line(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.line.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }
  updateFilter_operator(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tb98f_operator_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }

  
  uploadPhoto(file:File){
    var formData = new FormData();
    formData.append('file', file);
    formData.append('path', "approve");
    var request = new XMLHttpRequest();
    request.open('POST', environment.url+"/api/uploadToServerWithPath.php");
    request.send(formData);
  }


  openDeleteDialog(id:string) {

    let dialogRef = this.dialog.open(approveDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to delete this?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
          this.delete(id);
        console.log('---result---',result,id);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openEditDialog(){
    let dialogRef = this.dialog.open(approveDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.secret_code.value !=null && this.approveItemlCtrl.value !=undefined && this.approvePersonCtrl.value !=undefined && this.approveLevelCtrl.value !=undefined){
          this.edit();
        }else{
          this.warningDialog('Please fill in Code, Name, CT Value , Administrator!');
        }
      
       // console.log('---result---',result,this.user_selected.value.length,this.form.controls.code.value,this.form.controls.name.value,this.form.controls.ct.value);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openDialog(){
    let dialogRef = this.dialog.open(approveDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.secret_code.value !=null && this.approveItemlCtrl.value !=undefined && this.approvePersonCtrl.value !=undefined && this.approveLevelCtrl.value !=undefined){
          this.save();
        }else{
          this.warningDialog('Please fill in approve item, level, persion and secret code!');
        }
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }

  warningDialog(message: string) {

    let dialogRef = this.dialog.open(WarningApproveDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {

        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }
}
//dialog
@Component({
  selector: 'approve-dialog',
  templateUrl: 'dialog.html',
})
export class approveDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<approveDialog>) {}
}

//warning
@Component({
  selector: 'warning-approve-dialog',
  templateUrl: 'warning.html',
})
export class WarningApproveDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningApproveDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/approve/approve.ts